export default class Footer {
	constructor(el) {
		this.el = el;
		this.mobileNavItems = this.el.querySelectorAll("[js-footer-nav-item]");
		this.init();
	}

	init() {
		this.mobileNavItems.forEach((el) => {
			const submenuToggleBtn = el.querySelector(".submenu-toggle-btn");
			const submenu = el.querySelector(".footer__nav-mobile-list-item-submenu-wrapper");

			if (submenuToggleBtn && submenu) {
				submenuToggleBtn.addEventListener("click", (e) => this.toggleSubmenu(submenuToggleBtn, submenu));
			}
		});
	}

	toggleSubmenu(btn, submenu) {
		const isOpen = btn.getAttribute("aria-expanded") === "true";

		if (isOpen) {
			// close
			btn.setAttribute("aria-expanded", false);
			submenu.classList.remove("--expanded");
		} else {
			this.mobileNavItems.forEach((el) => {
				const submenuToggleBtn = el.querySelector(".submenu-toggle-btn");
				const sub = el.querySelector(".footer__nav-mobile-list-item-submenu-wrapper");
				submenuToggleBtn.setAttribute("aria-expanded", false);
				sub.classList.remove("--expanded");
			});
			// open
			btn.setAttribute("aria-expanded", true);
			submenu.classList.add("--expanded");
		}
	}
}
